module.exports = __webpack_public_path__ + "img/img-card-1.aa0186a5.svg";